var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddNoteHovering(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 228,
    height: 78,
    viewBox: "0 0 228 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_55_5302)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 220,
    height: 70,
    rx: 8,
    fill: "#00D3AB",
    fillOpacity: 0.1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 0.5,
    width: 219,
    height: 69,
    rx: 7.5,
    stroke: "#00D3AB",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 11,
    width: 48,
    height: 48,
    rx: 4,
    fill: "#00D3AB",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3333 25.8333V28.3333H28.8333V29.9999H31.3333V32.4999H32.9999V29.9999H35.4999V28.3333H32.9999V25.8333H31.3333ZM37.1666 29.1666C37.1666 31.928 34.928 34.1666 32.1666 34.1666C31.5822 34.1666 31.0212 34.0663 30.4999 33.8821V41.6721C30.4999 42.1292 30.8724 42.4999 31.3318 42.4999H39.6666V37.4999C39.6666 37.0416 40.0416 36.6666 40.4999 36.6666H45.4999V28.332C45.4999 27.8728 45.1293 27.4999 44.6721 27.4999H36.8821C37.0663 28.0212 37.1666 28.5822 37.1666 29.1666ZM45.4999 38.3333L41.3333 42.4974V38.3333H45.4999Z",
    fill: "#00D3AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.459 34.2852V35.5156H80.8086V38.5098H85.7031V39.7402H74.4102V38.5098H79.2773V35.5156H75.709V29.8418H77.2676V34.2852H84.459ZM96.5586 35.3379V36.541H87.8906V29.8281H96.4492V31.0586H89.4355V32.5488H96.1621V33.7383H89.4355V35.3379H96.5586ZM97.8027 38.4688V39.7129H86.5098V38.4688H97.8027ZM113.197 36.2812V37.5254H108.303V41.2305H106.799V37.5254H101.932V36.2812H113.197ZM112.145 30.3203V31.5234H108.33C108.474 32.7471 110.08 34.0254 112.555 34.3262L111.994 35.5293C109.95 35.2695 108.364 34.3672 107.564 33.1777C106.751 34.3809 105.151 35.2695 103.094 35.5293L102.547 34.3262C105.015 34.0254 106.635 32.7676 106.785 31.5234H102.971V30.3203H106.799V28.8711H108.303V30.3203H112.145ZM123.711 28.8574V33.6836H125.543V34.9551H123.711V41.1895H122.193V28.8574H123.711ZM120.443 30.1426C120.443 33.7793 118.939 36.9648 114.824 38.9883L113.963 37.8125C116.971 36.3154 118.598 34.21 118.912 31.4004H114.633V30.1426H120.443ZM135.811 28.8574V33.7793H137.711V35.0371H135.811V41.2168H134.307V28.8574H135.811ZM133.35 30.7578V31.9746H126.062V30.7578H128.988V29.0352H130.506V30.7578H133.35ZM129.754 32.7812C131.531 32.7812 132.857 33.9844 132.857 35.6934C132.857 37.4023 131.531 38.5918 129.754 38.5918C127.949 38.5918 126.623 37.4023 126.637 35.6934C126.623 33.9844 127.949 32.7812 129.754 32.7812ZM129.754 34.0254C128.783 34.0254 128.086 34.6816 128.086 35.6934C128.086 36.7051 128.783 37.3477 129.754 37.334C130.697 37.3477 131.395 36.7051 131.408 35.6934C131.395 34.6816 130.697 34.0254 129.754 34.0254ZM148.553 28.8574V41.2168H147.021V28.8574H148.553ZM144.861 30.1699C144.861 33.8477 143.439 36.9785 139.105 39.0293L138.312 37.8125C141.546 36.2744 143.05 34.1826 143.316 31.373H138.941V30.1699H144.861Z",
    fill: "#0D0D0D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_55_5302",
    x: 0,
    y: 0,
    width: 228,
    height: 78,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.827451 0 0 0 0 0.670588 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_55_5302"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_55_5302",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddNoteHovering);
export default __webpack_public_path__ + "static/media/add_note_hovering.06854cdea232f85c6a4a2f897fa0bdbe.svg";
export { ForwardRef as ReactComponent };